import React from 'react';
import '../styles/Footer.css';
import { useNavigate } from 'react-router-dom';
import fcbLogo from '../images/Fcb_logo.png';
function Footer() {

    const navigate = useNavigate();

    return (
        <div className='Footer'>
        <div className='FooterContent'>
            <h3 className='FooterH3'>
            Copyright 2023 Hazebroucq bénévoles Amicale de la Gare de Trôo
            </h3>
            <a href='https://www.facebook.com/GareDeTroo' target='_blank'>
                <img src={fcbLogo} className='fcb-logo' alt='logo Facebook' />
            </a>
        </div>
        </div>
    );
};

export default Footer;